import { parseBoolean } from '@amazon/vinyl-util'
import { readStoredDebug } from '@/core/debugPreference'
import { setForcedErrorsEnabled } from '@/util/forceError'
import { queryParam } from '@/util/queryParams'

// Precedence: `?debug=` param, then the persisted preference (the What's New heading gesture), then off.
const debugParam = queryParam('debug')

export const debug = debugParam != null ? parseBoolean(debugParam) : (readStoredDebug() ?? false)

setForcedErrorsEnabled(debug)
